<template>
  <div class="container pb-0">
    <h1 class="header-title text-center pb-3">Unser Team</h1>
    <div class="row row-cols-1 row-cols-md-3 g-4 px-3">
      <div class="col">
        <div class="card shadow">
          <div
            class="position-relative"
            @mouseenter="openSkill(0)"
            @mouseleave="closeSkill(null)"
          >
            <img
              src="../assets/images/nico.png"
              class="card-img-top"
              alt="..."
            />
            <Transition>
              <div
                v-if="showSkill == 0"
                class="position-absolute w-100 top-50 start-50 translate-middle filter-dark rounded-top"
              >
                <p
                  lang="de"
                  class="text-white mx-autoå lh-large bio p-5"
                  :class="[viewStore.isMobile ? 'fs-6' : 'fs-5']"
                >
                  Dotterhausen – Schnitt – Berlin: Für sein Audiodesign Studium
                  zieht Nico früh nach Berlin und gibt als Sound Engineer bei
                  der Postproduktion von größeren Filmprojekten oder bei
                  Livesendungen des RBB und ZDF den Ton an. Bei VAP mischt er
                  unsere Hörbücher und Hörspiele. Wir sind sicher, dass man in
                  Zukunft noch einiges von Nico hören wird.
                </p>
              </div>
            </Transition>
          </div>

          <div class="card-body rounded-bottom-3">
            <h5 class="card-title fw-bold">Nico</h5>
            <div class="card-text">
              <div class="profession">Schnitt & Produktion</div>
              <div>nicmes1992@gmail.com</div>
            </div>
            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <div
            class="position-relative"
            @mouseenter="openSkill(1)"
            @mouseleave="closeSkill(null)"
          >
            <img
              src="../assets/images/emilie.png"
              class="card-img-top"
              alt="..."
            />
            <Transition>
              <div
                v-if="showSkill == 1"
                class="position-absolute w-100 top-50 start-50 translate-middle filter-dark rounded-top"
              >
                <p
                  lang="de"
                  class="text-white mx-autoå lh-large bio p-5"
                  :class="[viewStore.isMobile ? 'fs-6' : 'fs-5']"
                >
                  Alle hier haben ein Ohr dafür, wann etwas gut klingt. Der
                  Unterschied ist, dass Emilie nichts von Tontechnik versteht:
                  Dafür versteht sie, was wir sagen wollen und sorgt dafür, dass
                  ihr unsere Gedanken lesen könnt. Mit flinker Feder,
                  säbelartigem Scharfsinn und aufmerksamen Adleraugen fängt sie
                  das Wesen der Dinge mit Sätzen ein, die nicht klingen wie
                  dieser.
                </p>
              </div>
            </Transition>
          </div>

          <div class="card-body rounded-bottom">
            <h5 class="card-title fw-bold">Emi</h5>
            <div class="card-text">
              <div class="profession">Copywriter</div>
              <div>emimariemaes@gmail.com</div>
            </div>
            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <div
            class="position-relative"
            @mouseenter="openSkill(2)"
            @mouseleave="closeSkill(null)"
          >
            <img
              src="../assets/images/jannes.png"
              class="card-img-top"
              alt="..."
            />
            <Transition>
              <div
                v-if="showSkill == 2"
                class="position-absolute w-100 top-50 start-50 translate-middle filter-dark rounded-top"
              >
                <p
                  lang="de"
                  class="text-white mx-autoå lh-large bio p-5"
                  :class="[viewStore.isMobile ? 'fs-6' : 'fs-5']"
                >
                  Als Videograph gestaltet Jannes seine Welt(en) nach seinen
                  Vorstellungen: Vom Land in die Berliner Werbebranche als
                  Junior Art Director, gestern Experte für Grafikdesign, heute
                  für Kameraequipment, morgen für Webdesign. Neben den
                  geschulten Ohren seines Teams hat er das Auge für Details. So
                  anspruchsvoll ein Projekt auch sein mag – mit Jannes gestaltet
                  es sich leicht.
                </p>
              </div>
            </Transition>
          </div>

          <div class="card-body rounded-bottom">
            <h5 class="card-title fw-bold">Jannes</h5>
            <div class="card-text">
              <div class="profession">Videoproduktion</div>
              <div>hoppe.jannes@googlemail.com</div>
            </div>
            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <div
            class="position-relative"
            @mouseenter="openSkill(3)"
            @mouseleave="closeSkill(null)"
          >
            <img
              src="../assets/images/malte.png"
              class="card-img-top"
              alt="..."
            />
            <Transition>
              <div
                v-if="showSkill == 3"
                class="position-absolute w-100 top-50 start-50 translate-middle filter-dark rounded-top"
              >
                <p
                  lang="de"
                  class="text-white mx-autoå lh-large bio p-5"
                  :class="[viewStore.isMobile ? 'fs-6' : 'fs-5']"
                >
                  Als Urberliner trifft Malte mit Multikompetenz den
                  multikulturellen Ton der Hauptstadt: Neben seinem Master in
                  Audiokommunikation und Audiotechnologie ist er als Gitarrist
                  Teil von The xUrbs, seine Expertise reicht von Musikproduktion
                  bis Software Entwicklung. Zusammen mit Malte werden Dinge auf
                  Erfolg programmiert.
                </p>
              </div>
            </Transition>
          </div>

          <div class="card-body rounded-bottom">
            <h5 class="card-title fw-bold">Malte</h5>
            <div class="card-text">
              <div class="profession">Programmierer & Design</div>
              <div>schneidermalte49@gmail.com</div>
            </div>
            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="animation" class="container w-25 py-0">
    <div id="img-container" ref="sloganImg">
      <video
        class="img-fluid"
        src="../assets/videos/square-logo.mp4"
        autoplay
        loop
        muted
        defaultMuted
        playsinline
      ></video>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();
const showSkill = ref(null);

const openSkill = (index) => {
  showSkill.value = index;
};
const closeSkill = () => {
  showSkill.value = null;
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.filter-dark {
  background-color: rgba(0, 0, 0, 0.7) !important;
  z-index: 100 !important;
  height: 100%;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.card-body {
  // background-color: rgb(0, 0, 0);
  background-color: white;
  color: black;
}

.card-title {
  color: #fc4667 !important;
  font-size: 1.6rem;
}

.card-text {
  // color: rgb(212, 212, 212);
  color: black;
}

.card {
  border: none;
  border-radius: none;
}
.profession {
  font-weight: 600;
}
</style>
